import CenterIDSelect from "../../../components/inputs/CenterIDSelect";
import { useConnectedUser } from "../../../hooks/user.hooks";
import i18n from "../../../i18n";
import { Center } from "../../../types/center.types";

const OrderSelectCenter = ({
	id,
	setId,
}: {
	id: string | undefined;
	setId?: (id: string) => void;
}) => {
	const user = useConnectedUser();

	if (!user?.isSuperAdmin) return null;
	return (
		<CenterIDSelect
			placeholder={i18n.t("input.select.center.placeholder")}
			centerSelected={id}
			setCenterSelected={(center?: Center) => {
				if (setId) {
					setId(center?.id?.toString() ?? "");
				}
			}}
		/>
	);
};

export default OrderSelectCenter;
